<div class="w-100 flex-row flex-wrap justify-start items-stretch">
  <div class="header w-100 flex-row space-between items-center">
    <span class="text-muted"><strong>moovs configurations in testing status</strong></span>
  </div>
  @if (busy) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  @let ds = dataSource;
  @if(ds){
    <table mat-table  [dataSource]="ds ?? []" matSort matSortActive="lastAddedAt" matSortDirection="asc" class="w-100">
      <ng-container matColumnDef="clientName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
        <td mat-cell *matCellDef="let mcs" class="wrap-cell">{{mcs.clientName}}</td>
      </ng-container>
      <ng-container matColumnDef="moovConfigurationDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>moov Configuration</th>
        <td mat-cell *matCellDef="let mcs" class="wrap-cell">{{mcs.moovConfigurationDescription}}</td>
      </ng-container>
      <ng-container matColumnDef="moovName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>moov</th>
        <td mat-cell *matCellDef="let mcs" class="wrap-cell">{{mcs.moovName}}</td>
      </ng-container>
      <ng-container matColumnDef="lastAddedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Executed Date</th>
        <td mat-cell *matCellDef="let mcs" class="wrap-cell">{{getExecutionDate(mcs)}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let mcs; columns: displayedColumns;" (click)="selectionChanged(mcs)"></tr>
    </table>
  }
  <mat-divider class="w-100"></mat-divider>
  <div class="w-100 flex-row justify-end items-center">
    @if (ds?.data!.length === 0) {
      <p class="py-5 mb-0 text-center">No data available</p>
    }
    <div [hidden]="ds?.data!.length === 0">
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons (page)="pageChanged($event)"></mat-paginator>
    </div>
  </div>